module.exports = __webpack_public_path__ + "static/city-of-whittlesea-logo-large-4ff772551a77f69e5852b3394611444a.png";